<template>
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">
        <i class="bi bi-play-circle me-2"></i>Health Education
      </h5>
    </div>
    <div class="card-body">
      <div v-if="videos.length === 0" class="text-center text-muted py-3">
        <i class="bi bi-camera-video" style="font-size: 2rem;"></i>
        <p class="mt-2 mb-0">Health education videos coming soon</p>
      </div>
      <div v-else>
        <div
          v-for="video in videos.slice(0, 3)"
          :key="video.id"
          class="video-item mb-3"
          @click="$emit('watch-video', video)"
        >
          <div class="video-thumbnail">
            <img :src="video.thumbnail" :alt="video.title">
            <div class="play-overlay">
              <i class="bi bi-play-fill"></i>
            </div>
          </div>
          <div class="video-info">
            <h6 class="video-title">{{ video.title }}</h6>
            <small class="text-muted">{{ video.duration }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthVideos',
  props: {
    videos: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['watch-video']
}
</script>

<style scoped>
.video-item {
  display: flex;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.video-item:hover {
  background: #f8f9fa;
}

.video-thumbnail {
  position: relative;
  width: 80px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.7);
  color: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-title {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  line-height: 1.3;
}
</style>
